<template>
  <div class="app-container">
    <div class="banner">
      <el-carousel trigger="click" height="35rem">
        <el-carousel-item v-for="(item,index) in ImgList" :key="item.src+'123'+index" >
          <h3 class="small"><el-link :href="item.url"><el-image style="width: 100%;" :src="item.src" fit="contain" /></el-link></h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="games-container">
      <div class="game-list-container">
        <div class="games-title">最新遊戲</div>
        <div class="game-cards-container">
               <el-card :body-style="{ padding: '0px'}">
                <div class="box-card">
                  <a href="https://mh30.moxgame.com" target="_blank">
                    <img src="https://mh30.moxgame.com/images/gameshort.jpg" class="img-heading" alt="MOXGAME 墨魂">
                  </a>
                <div style="padding: 14px">
                  <div>
                    <div class="user-item">MOXGAME 墨魂</div>
                    <div class="user-item share-butt">
                      <a href="https://www.facebook.com/moxmh30" target="_blank">
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJFJREFUeNpi/P//PwMy2LZtGwMaMABiASj7gZeX1wNkSSYG3MABiN8D8Xkg3g/FCeiK8BkwH8lmnIAFj5wCEvsCEG+E0kQbgAwKgfgAsS5wgGJkEA8VO4BuEC4D6tHEkAPvALGBiA18IMYLC6C27EcLgwvYwgGbAQ+gmAEtFrAGIqleGDWAxLzgiBYLWAFAgAEAdB8eR+qRcPsAAAAASUVORK5CYII="
                          class="img-pointer"/>
                      </a>
                    </div>
                  </div>
                  <div class="description-active">遊戲已上線，立即加入！</div>
                  <div class="game-type">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIRJREFUeNrUUyEOwCAMbJdhEFgMlv8/CItGIDCIbk2AELIFwQQ7QdKmXNs7QCKCFRywiGWCkw/nHHnvQUo5vZBSAmMMWGuxETBKckpwN9tMg01cqOKMAr2hF/ubCbTWEEJoyZwzxBhbrJQCIUSLub4Cy1+g0et+HR754Y1gT/BjGy8BBgCIByxW4GadOgAAAABJRU5ErkJggg=="
                    /><span>MMORPG</span>
                  </div>
                </div>
                </div>
              </el-card>
        </div>
      </div>
    </div>
    <div class="games-container">
      <div class="game-list-container">
        <div class="games-title">過往遊戲</div>
        <div class="game-cards-container">
               <el-card :body-style="{ padding: '0px'}">
                <div class="box-card">
                  <a href="https://mhmso.moxgame.com" target="_blank">
                    <img src="https://mhmso.moxgame.com/images/bgmsologo.jpg" class="img-heading">
                  </a>
                <div style="padding: 14px">
                  <div>
                    <div class="user-item">滅魂墨香</div>
                    <div class="user-item share-butt">
                      <a href="https://www.facebook.com/mhmso1" target="_blank">
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJFJREFUeNpi/P//PwMy2LZtGwMaMABiASj7gZeX1wNkSSYG3MABiN8D8Xkg3g/FCeiK8BkwH8lmnIAFj5wCEvsCEG+E0kQbgAwKgfgAsS5wgGJkEA8VO4BuEC4D6tHEkAPvALGBiA18IMYLC6C27EcLgwvYwgGbAQ+gmAEtFrAGIqleGDWAxLzgiBYLWAFAgAEAdB8eR+qRcPsAAAAASUVORK5CYII="
                          class="img-pointer"/>
                      </a>
                    </div>
                  </div>
                  <div class="description-inactive">遊戲已結業，關閉伺服器。</div>
                  <div class="game-type">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIRJREFUeNrUUyEOwCAMbJdhEFgMlv8/CItGIDCIbk2AELIFwQQ7QdKmXNs7QCKCFRywiGWCkw/nHHnvQUo5vZBSAmMMWGuxETBKckpwN9tMg01cqOKMAr2hF/ubCbTWEEJoyZwzxBhbrJQCIUSLub4Cy1+g0et+HR754Y1gT/BjGy8BBgCIByxW4GadOgAAAABJRU5ErkJggg=="
                    /><span>MMORPG</span>
                  </div>
                </div>
                </div>
              </el-card>
              <el-card :body-style="{ padding: '0px'}">
                <div class="box-card">
                  <a href="https://67mso.moxgame.com" target="_blank">
                    <img src="https://67mso.moxgame.com/images/bgmsologo.jpg" class="img-heading">
                  </a>
                <div style="padding: 14px">
                  <div>
                    <div class="user-item">綠茶墨香</div>
                    <div class="user-item share-butt">
                      <a href="https://www.facebook.com/67mso" target="_blank">
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJFJREFUeNpi/P//PwMy2LZtGwMaMABiASj7gZeX1wNkSSYG3MABiN8D8Xkg3g/FCeiK8BkwH8lmnIAFj5wCEvsCEG+E0kQbgAwKgfgAsS5wgGJkEA8VO4BuEC4D6tHEkAPvALGBiA18IMYLC6C27EcLgwvYwgGbAQ+gmAEtFrAGIqleGDWAxLzgiBYLWAFAgAEAdB8eR+qRcPsAAAAASUVORK5CYII="
                          class="img-pointer"/>
                      </a>
                    </div>
                  </div>
                  <div class="description-inactive">遊戲已結業，關閉伺服器。</div>
                  <div class="game-type">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIRJREFUeNrUUyEOwCAMbJdhEFgMlv8/CItGIDCIbk2AELIFwQQ7QdKmXNs7QCKCFRywiGWCkw/nHHnvQUo5vZBSAmMMWGuxETBKckpwN9tMg01cqOKMAr2hF/ubCbTWEEJoyZwzxBhbrJQCIUSLub4Cy1+g0et+HR754Y1gT/BjGy8BBgCIByxW4GadOgAAAABJRU5ErkJggg=="
                    /><span>MMORPG</span>
                  </div>
                </div>
                </div>
              </el-card>
               <el-card :body-style="{ padding: '0px'}">
                <div class="box-card">
                  <a href="https://15mso.moxgame.com" target="_blank">
                    <img src="https://15mso.moxgame.com/images/bgmsologo.jpg" class="img-heading">
                  </a>
                <div style="padding: 14px">
                  <div>
                    <div class="user-item">如意墨香</div>
                    <div class="user-item share-butt">
                      <a href="https://www.facebook.com/15mso" target="_blank">
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJFJREFUeNpi/P//PwMy2LZtGwMaMABiASj7gZeX1wNkSSYG3MABiN8D8Xkg3g/FCeiK8BkwH8lmnIAFj5wCEvsCEG+E0kQbgAwKgfgAsS5wgGJkEA8VO4BuEC4D6tHEkAPvALGBiA18IMYLC6C27EcLgwvYwgGbAQ+gmAEtFrAGIqleGDWAxLzgiBYLWAFAgAEAdB8eR+qRcPsAAAAASUVORK5CYII="
                          class="img-pointer"/>
                      </a>
                    </div>
                  </div>
                  <div class="description-inactive">遊戲已結業，關閉伺服器。</div>
                  <div class="game-type">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIRJREFUeNrUUyEOwCAMbJdhEFgMlv8/CItGIDCIbk2AELIFwQQ7QdKmXNs7QCKCFRywiGWCkw/nHHnvQUo5vZBSAmMMWGuxETBKckpwN9tMg01cqOKMAr2hF/ubCbTWEEJoyZwzxBhbrJQCIUSLub4Cy1+g0et+HR754Y1gT/BjGy8BBgCIByxW4GadOgAAAABJRU5ErkJggg=="
                    />
                    <span>MMORPG</span>
                  </div>
                </div>
                </div> 
              </el-card>
               <el-card :body-style="{ padding: '0px'}">
                <div class="box-card">
                  <a href="https://15mso.moxgame.com" target="_blank">
                    <img src="https://15mso.moxgame.com/images/bgmsologo16.jpg" class="img-heading">
                  </a>
                <div style="padding: 14px">
                  <div>
                    <div class="user-item">圓月墨香</div>
                    <div class="user-item share-butt">
                      <a href="https://www.facebook.com/15mso" target="_blank">
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJFJREFUeNpi/P//PwMy2LZtGwMaMABiASj7gZeX1wNkSSYG3MABiN8D8Xkg3g/FCeiK8BkwH8lmnIAFj5wCEvsCEG+E0kQbgAwKgfgAsS5wgGJkEA8VO4BuEC4D6tHEkAPvALGBiA18IMYLC6C27EcLgwvYwgGbAQ+gmAEtFrAGIqleGDWAxLzgiBYLWAFAgAEAdB8eR+qRcPsAAAAASUVORK5CYII="
                          class="img-pointer"/>
                      </a>
                    </div>
                  </div>
                  <div class="description-inactive">遊戲已結業，關閉伺服器。</div>
                  <div class="game-type">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIRJREFUeNrUUyEOwCAMbJdhEFgMlv8/CItGIDCIbk2AELIFwQQ7QdKmXNs7QCKCFRywiGWCkw/nHHnvQUo5vZBSAmMMWGuxETBKckpwN9tMg01cqOKMAr2hF/ubCbTWEEJoyZwzxBhbrJQCIUSLub4Cy1+g0et+HR754Y1gT/BjGy8BBgCIByxW4GadOgAAAABJRU5ErkJggg=="
                    />
                    <span>MMORPG</span>
                  </div>
                </div>
                </div> 
              </el-card>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>

export default {
  data() {
    return {
      ImgList: [
        {src: require('@/assets/images/banner01.jpg'), url:'https://mh30.moxgame.com'},
        {src: require('@/assets/images/banner02.jpg'), url:'#'},
        {src: require('@/assets/images/banner03.jpg'), url:'#'},
        {src: require('@/assets/images/banner04.jpg'), url:'#'},
        {src: require('@/assets/images/banner05.jpg'), url:'#'},
      ]
    }
  }
};
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app-container {
  display: block;
}
.banner {
  padding-bottom: 20px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  
  margin: 0;
}
.el-carousel { height: 35rem; /* 桌面 */ } @media (max-width: 1200px) { .el-carousel { height: 15vh; /* 手機 */ } }

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.games-container {
  max-width: 1281px;
  margin: auto;
}
.game-list-container {
  padding-bottom: 50px;
}
.games-title {
  margin-top: 50px;
  margin-left: 12px;
  font-size: 24px;
  font-family: Noto Sans KR, sans-serif;
  font-weight: 400;
  color: #000;
  opacity: 0.87;
  padding-bottom: 20px;
}
.img-heading {
  max-width: 296px;
  max-height: 196px;
  width: 296px;
  height: 196px;
  display: block;
}
.game-cards-container {
  max-width: 1305px;
  margin-left: 12px;
      transition: all .4s;
}
.el-card {
  border: none;
  border-radius: 0px;
  display: inline-block;
  overflow: hidden;
  margin-top:10px;
  margin-right:10px;

}
.share-butt {
    float: right;
}
.img-pointer {
    cursor: pointer;
}
.user-item {
    display: inline-block;
}
.description-active {
    font-size: 12px;
    color: #66CD00;
    margin-top: 5px;
}
.description-inactive {
    font-size: 12px;
    color: #ccc;
    margin-top: 5px;
}

.game-type {
    font-size: 12px;
    color: #ccc;
    margin-top: 10px;
}
.game-type img {
    margin-right: 10px;
    margin-bottom: -3px;
}

.box-card {

padding: 0px; 
width: 296px;
}


</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue